import type { AuditLogEntry } from '@core/api/auditLog';
import { AuditAction } from '@core/enum/auditAction';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { formatItemIdList } from '../../utils/jobOrderPrint';
import { HistoryLines } from '../HistoryLines';
import { readItemColors, readItemLabels } from '../historyLabel';

type JobOrderPrintedEntry = AuditLogEntry & {
  action: AuditAction.JobOrderPrinted;
  metadata: {
    itemIds?: number[];
    trigger?: 'production_batch' | 'production_reprint' | 'order_reprint';
  } | null;
};

export const renderJobOrderPrinted: AuditLogRenderer = (entry) => {
  const { metadata } = entry as JobOrderPrintedEntry;
  const itemIds = metadata?.itemIds ?? [];
  const isReprint = metadata?.trigger !== 'production_batch';
  const verb = isReprint ? 'reprinted' : 'printed';

  const action = `Job orders ${verb}`;
  const labels = readItemLabels(entry);
  if (labels) {
    return (
      <HistoryLines
        title={labels}
        action={action}
        color={readItemColors(entry) ?? undefined}
      />
    );
  }

  if (itemIds.length === 0) {
    return <>{action}</>;
  }

  const noun = itemIds.length === 1 ? 'item' : 'items';

  return (
    <HistoryLines
      title={`${noun} ${formatItemIdList(itemIds)}`}
      action={action}
    />
  );
};
